module.exports = __webpack_public_path__ + "img/library-night.814cbfa1.jpg";